(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-slider"] && !window.DesignMode) return;
  try {
    
  $('.slick-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-product"] && !window.DesignMode) return;
  try {
    
tabs = document.querySelectorAll('.custom-tab');
tabContents = document.querySelectorAll('.custom__tab-content');
tabs[0].classList.add('active');
tabContents[0].classList.add('active');
tabs.forEach(function(tab) {
  tab.addEventListener('click', function() {
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content) {
      content.classList.remove('active');
    });

    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
    
    // Trigger slick initialization on tab change
    if (window.innerWidth <= 1240) { // Mobile condition
      setTimeout(function() {
        $('.slider').slick('setPosition');
        $('.slider').slick('slickGoTo', 0, true);
      }, 100);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
